var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_3779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.229004H1.77187C0.792187 0.229004 0 1.00244 0 1.95869V22.4946C0 23.4509 0.792187 24.229 1.77187 24.229H22.2234C23.2031 24.229 24 23.4509 24 22.4993V1.95869C24 1.00244 23.2031 0.229004 22.2234 0.229004ZM7.12031 20.6806H3.55781V9.22432H7.12031V20.6806ZM5.33906 7.66338C4.19531 7.66338 3.27188 6.73994 3.27188 5.60088C3.27188 4.46182 4.19531 3.53838 5.33906 3.53838C6.47813 3.53838 7.40156 4.46182 7.40156 5.60088C7.40156 6.73525 6.47813 7.66338 5.33906 7.66338ZM20.4516 20.6806H16.8937V15.1118C16.8937 13.7853 16.8703 12.0743 15.0422 12.0743C13.1906 12.0743 12.9094 13.5228 12.9094 15.0181V20.6806H9.35625V9.22432H12.7687V10.7899H12.8156C13.2891 9.88994 14.4516 8.93838 16.1813 8.93838C19.7859 8.93838 20.4516 11.3103 20.4516 14.3946V20.6806Z",
    fill: "#313E4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_3779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.229004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkein);
export default __webpack_public_path__ + "static/media/linkein.1f2f5649dc362e3815ded56a2f91507b.svg";
export { ForwardRef as ReactComponent };